<template>
  <div class="tradingview-chart">
    <div id="tradingview_chart_container" :class="[getOS == 'ios' ? 'ios' : '']"></div>
  </div>
</template>

<script>
require("../../../assets/vendor/tradingview/charting_library.min.js");
import Datafeeds from "../../../assets/vendor/tradingview/datafeed/udf/goldSpotDatafeed";

export default {
  name: "gold-spot-tradingview-chart",
  metaInfo() {
    return {
      title: this.trasformTitleName
    };
  },
  props: {
    // Props to receive
    name: {
      type: String,
      required: true,
      default: ""
    },
    showChartCover: {
      type: Boolean,
      default: true
    },
    chartCoverFn: {
      type: Function,
      default: () => {}
    },
    tradingviewConfig: {
      // eslint-disable-next-line no-unused-vars
      validator: Obj => {
        return true;
      },
      default: () => {
        return {
          fullscreen: false,
          symbol: "",
          interval: "D",
          container_id: "tradingview_chart_container",
          datafeed: new Datafeeds.UDFCompatibleDatafeed("/api/gold/spot"),
          library_path: "/vendor/tradingview/",
          locale: "en",
          timezone: "Asia/Bangkok",
          autosize: true,
          height: "300px",
          disabled_features: [
            "use_localstorage_for_settings",
            "header_symbol_search"
          ],
          time_frames: [
            { text: "1d", resolution: "D", description: "1 DAY", title: "1d" },
            { text: "7d", resolution: "D", description: "7 DAYS", title: "7d" },
            {
              text: "1m",
              resolution: "D",
              description: "1 MONTHS",
              title: "1m"
            },
            {
              text: "3m",
              resolution: "D",
              description: "3 MONTHS",
              title: "3m"
            },
            {
              text: "6m",
              resolution: "D",
              description: "6 MONTHS",
              title: "6m"
            },
            {
              text: "1y",
              resolution: "D",
              description: "1 Years",
              title: "1y"
            },
            {
              text: "3y",
              resolution: "D",
              description: "3 Years",
              title: "3y"
            },
            {
              text: "5y",
              resolution: "D",
              description: "5 Years",
              title: "5y"
            },
            {
              text: "10y",
              resolution: "D",
              description: "10 Years",
              title: "10y"
            },
            { text: "1000y", resolution: "D", description: "All", title: "All" }
          ],
          overrides: {
            "mainSeriesProperties.style": 1, //Default Candle Style
            "mainSeriesProperties.areaStyle.color1": "#f5f9fd",
            "mainSeriesProperties.areaStyle.color2": "#f5f9fd",
            "mainSeriesProperties.areaStyle.linecolor": "#4c99ec",
            "mainSeriesProperties.areaStyle.linestyle": 1,
            "mainSeriesProperties.areaStyle.linewidth": 2,
            "mainSeriesProperties.areaStyle.priceSource": "high"
          }
        };
      }
    }
  },
  data: () => ({
    tv: null,
    lang: "en",
    goldType: {
      gold_spot: "ทองคำโลก"
    }
  }),
  watch: {
    name() {
      this.tv.setSymbol(this.name, this.tv.chart().resolution(), null);
      return this.name;
    }
  },
  methods: {
    getParameterByName() {
      let name = "lang";
      name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
      var regex = new RegExp("[\\?&]" + name + "=([^&#]*)");

      var results = null;
      if (typeof location != "undefined") results = regex.exec(location.search);
      this.lang =
        results === null
          ? ""
          : decodeURIComponent(results[1].replace(/\+/g, " "));
    }
  },
  computed: {
    getOS() {
      return this.$liff.getOS();
    },
    trasformTitleName() {
      return this.goldType[this.name];
    }
  },
  created() {
    this.$store.commit("global/SET_SHOW_FOOTER", false);
  },
  mounted() {
    setTimeout(() => {
      //FIX SCREEN POSITION
      var metaTag = document.createElement("meta");
      metaTag.name = "viewport";
      metaTag.content =
        "width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=0";
      document.getElementsByTagName("head")[0].appendChild(metaTag);
      let tradingviewConfig = this.tradingviewConfig;
      tradingviewConfig.symbol = this.name;
      tradingviewConfig.locale = this.getParameterByName() || "en";
      let tvWidget = new TradingView.widget(tradingviewConfig);
      tvWidget.onChartReady(() => {});
      this.tv = tvWidget;
    }, 500);
  },
  destroyed() {
    this.$store.commit("global/SET_SHOW_FOOTER", true);
  }
};
</script>
<style lang='scss' scoped>
.tradingview-chart {
  padding: 0;
  #tradingview_chart_container {
    z-index: 10;
    height: 100vh;
  }
  .ios {
    @include manageiPhoneMedia;
  }
}

.js-hidden {
  display: block !important;
}

.chart-cover {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0px;
  background-color: black;
  opacity: 0.8;
}

.chart-cover-text {
  top: 50%;
  transform: translateY(-50%);
  position: relative;
  opacity: 1;
  color: white;
  font-size: 40px;
  text-align: center;
  padding: 0px 10px 0px 10px;
}
</style>

